import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { ProfilePhone } from '../profilePhone/ProfilePhone';
import { ProfileAnonymous } from '../profileAnonymous/ProfileAnonymous';
import { ProfilePublic } from '../profilePublic/ProfilePublic';

import styles from './styles.module.css';

export const ProfileTrust = ({ adId, isLoggedIn, owner, profileIdentity }) => {
    const showAnonymousProfile = owner.isAnonymous || false;

    return (
        <div data-testid="trustProfile">
            <div className={cn(styles.container, 'finn-trust-profile text-left')}>
                {showAnonymousProfile ? <ProfileAnonymous /> : <ProfilePublic identity={profileIdentity} />}
            </div>
            {owner.hasPhoneNumber && <ProfilePhone adId={adId} isLoggedIn={isLoggedIn} />}
        </div>
    );
};

ProfileTrust.propTypes = {
    adId: PropTypes.number.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    owner: PropTypes.object.isRequired,
    profileIdentity: PropTypes.object,
};
